import React from "react";
import TableData from "../../../../../../../../_components/TableData";
import { CreateNFeContext } from "../../../../Context";
import Currency from "react-currency-formatter";

export default (props) => {
  const createNFeContext = React.useContext(CreateNFeContext);
  const [data, setData] = React.useState([]);

  function handleChangeData() {
    const currency = (value) => (
      <Currency symbol="R$ " currency="BRL" quantity={value} />
    );

    if (createNFeContext.nfe) {
      const total_items = currency(createNFeContext.nfe.total_items || 0);
      const total_nfe = currency(
        createNFeContext.nfe.total_nfe -
          createNFeContext.nfe.identification.discount_value
      );
      const shipping_value = currency(createNFeContext.nfe.shipping_value || 0);
      const other_expenses = currency(createNFeContext.nfe.other_expenses || 0);
      const discount_value = currency(
        createNFeContext.nfe.identification.discount_value
      );
      const total_paid = currency(createNFeContext.nfe.total_paid);
      let left = currency(0);
      if (
        createNFeContext.nfe.total_paid >
        createNFeContext.nfe.total_nfe -
          createNFeContext.nfe.identification.discount_value
      ) {
        left = createNFeContext.nfe.total_paid - createNFeContext.nfe.total_nfe;
        left = currency(left || 0);
      }
      setData([
        {
          total_items,
          shipping_value,
          other_expenses,
          discount_value,
          total_paid,
          total_nfe,
          left 
        },
      ]);
    }
  }
  React.useEffect(handleChangeData, [
    createNFeContext.nfe,
    createNFeContext.nfe.total_paid,
    createNFeContext.nfe.identification.discount_value,
    createNFeContext.nfe.shipping_value,
    createNFeContext.nfe.other_expenses

  ]);
  return (
    <TableData
      data={data}
      tHead={[
        "Total dos Produtos",
        "Total Frete",
        "Outras Despesas",
        "Desconto",
        "Total Pago",
        "Total da NF-e",
        "Troco",
      ]}
      tBodyKeys={[
        "total_items",
        "shipping_value",
        "other_expenses",
        "discount_value",
        "total_paid",
        "total_nfe",
        "left",
      ]}
    />
  );
};



// WEBPACK FOOTER //
// ./src/views/Fiscal/NFe/Issuer/NFePaymentShipping/Payments/components/TableNFePaymentTotals/index.jsx